<template>
  <SelectAdv :name=name :value=value :search=search :init=init @update:modelValue="$emit('update:modelValue', $event)" />
</template>

<script>
import SelectAdv from '_lib/select_adv/SelectAdv.vue'
import darsan from "darsan"
import _ from "underscore"
import $ from "jquery"

const _typeToIcon =
    {
      switch: "sitemap",
      pon: "lightbulb-o",
      pontree: "tree",
      smart: "archive",
    }

export default {
  name: "DeviceInput",

  components: {SelectAdv},

  props: {
    name: {
      type: String,
    },
    modelValue: {
       type: String,
       default: null,
    },
  },
  
  emits: [ 'update:modelValue' ],

  methods: {    
/*
    init(opt) {
      return { id: null, name: "" }
    },
*/
    search(query) {
      return darsan.get("", "device", "/srv/search", { nameMask: query, type: ["switch","pon","pontree","smart", "any"] })
        .then(function (data) {

          return $.map(data, el => 
          { 
            return { 
              id: el.device_entity, 
              name: el.name_ru||dev.name,
              type: el.device_entity.replace(/[^a-z]/g,""),
              disabled: el.disabled, 
            }
          });
        })
    },
  }
}
</script>
